module.exports = __webpack_public_path__ + "static/img/choujiang@2x.7bee9e9.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/choujiang@2x.png
// module id = St4C
// module chunks = 1